import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { envIsNormal } from '@/constants/constants';
import { openModal } from '@/store/actions/modal';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import BffApiService from '@/shared/bffApiService';
import { BffComplianceOntarioCheckResponse } from '@lucky7ventures/bff-types';
import { useBffApiRequest } from '@/hooks/useBffApiRequest';
import { setOntarioCanPlay } from '@/store/actions/commonActions';
import { selectOntarioCanPlay } from '@/store/selectors/commonSelectors';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';

export function useOntarioCheck(): void {
  const dispatch = useDispatch();
  const { request } = useBffApiRequest<BffComplianceOntarioCheckResponse>();
  const ontarioCanPlay = useSelector(selectOntarioCanPlay);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    if (!envIsNormal()) {
      return;
    }

    // @ts-ignore
    request({
      apiMethod: BffApiService.ontarioCheck,
      successCallback: data => {
        triggerGTag(data ? GTagEvents.ontario_check_true : GTagEvents.ontario_check_false);
        dispatch(setOntarioCanPlay(data));
      },
    });
  }, []);

  // if user logs in, it will log the user out if he is in ontario
  useEffect(() => {
    if (!envIsNormal()) {
      return;
    }

    if (isAuthenticated && !ontarioCanPlay) {
      dispatch(openModal('ontarioCheck', {}, 101));
    }
  }, [isAuthenticated, ontarioCanPlay]);
}
